// Pure time utilities. No React, no styling, no I/O.

export const mDiff = (a, b) => {
  if (!a || !b) return 0
  const [ah, am] = a.split(':').map(Number)
  const [bh, bm] = b.split(':').map(Number)
  return (bh * 60 + bm) - (ah * 60 + am)
}

export function formatIsoTime(isoStr) {
  if (!isoStr) return null
  const str = String(isoStr).trim()
  const hasTimezone = /[Zz]|[+-]\d{2}:?\d{2}$/.test(str)
  const safeIso = hasTimezone ? str : str + 'Z'
  const dateObj = new Date(safeIso)
  if (isNaN(dateObj.getTime())) return '-'
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(dateObj)
}